var Container = /** @class */ (function () {
    function Container(name, type, id) {
        if (type === void 0) { type = ContainerType.Default; }
        this.id = id;
        this.name = name;
        this.type = type;
    }
    return Container;
}());
export default Container;
export var ContainerType;
(function (ContainerType) {
    ContainerType[ContainerType["Default"] = 0] = "Default";
    ContainerType[ContainerType["Dirty"] = 1] = "Dirty";
    ContainerType[ContainerType["Trip"] = 2] = "Trip";
})(ContainerType || (ContainerType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/models/Container.ts
// module id = null
// module chunks = 